module.exports = __webpack_public_path__ + "img/lock.5d27d4fb.svg";